import { BannerNotification } from '@hologram-dimension/banner-notification';
import { Link } from '@hologram-dimension/link';
import { FC } from 'react';
import { NewSupportTicket } from 'utils/constants/links';

const CustomPostpaidDisclaimer: FC<{
  variant?: 'rates' | 'billing';
}> = ({ variant = 'rates' }) => (
  <BannerNotification variant="caution" prefixOverride="Note">
    {variant === 'rates' && (
      <>
        Your organization is configured with custom billing. Data plan details may not match your
        active contract.{' '}
        <Link href={NewSupportTicket} type="inline">
          Contact support for assistance
        </Link>
      </>
    )}
    {variant === 'billing' && (
      <>
        Your organization is configured with custom billing. Billing data provided here is reference
        only and should be referenced from the invoices or other billing documents sent from your
        account team.{' '}
        <Link href={NewSupportTicket} type="inline">
          Contact support for assistance
        </Link>
      </>
    )}
  </BannerNotification>
);

export default CustomPostpaidDisclaimer;
